export default (state = {}, action) => {


    switch (action.type) {
        case 'SAVE_CONTACT_DETAILS':
            return {
                ...state,
                ...action.payload,
            };
        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/reducers/customerDetails_reducer.js